import { Query } from '@apollo/client/react/components';
import CardActionArea from '@mui/material/CardActionArea';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import { GET_BLOG_POSTS } from '../../helpers/graphql/posts';
import Link from '@mui/material/Link';

const BlogGrid = props => {
  return (
    <>
      <Query
        query={GET_BLOG_POSTS}
        variables={{
          author: props.author || 'travelfeed',
          limit: 4,
          tag: props.author ? undefined : 'travelfeedweekly',
          useBlacklist: false,
        }}
      >
        {({ data }) => {
          let posts;
          if (data) {
            posts = [
              // Pin posts here
              // {
              //   author: 'travelfeed',
              //   permlink: 'introducing-travelfeed-beta',
              //   title: 'Introducing TravelFeed Beta',
              // },
              ...data.posts,
            ];
          }
          return (
            <>
              {posts
                ? posts.map((post, i) => {
                    return (
                      <>
                        <div key={post._id}>
                          {i > 0 && (
                            <Divider variant="middle" className="pl-3 pr-3" />
                          )}
                          <Link
                            color="textPrimary"
                            href={`/@${post.author.username}/${post.permlink}`}
                          >
                            <CardActionArea className="pt-2 pb-2">
                              <div className="container-fluid">
                                <div className="row h-100">
                                  <div className="col-12">
                                    <ListItemText primary={post.title} />
                                  </div>
                                </div>
                              </div>
                            </CardActionArea>
                          </Link>
                        </div>
                      </>
                    );
                  })
                : [1, 2, 3, 4].map((_, i) => {
                    return (
                      <>
                        {i > 0 && (
                          <Divider variant="middle" className="pl-3 pr-3" />
                        )}
                        <CardActionArea className="pt-2 pb-2">
                          <div className="container-fluid">
                            <div className="row h-100">
                              <div className="col-12">
                                <Skeleton
                                  variant="text"
                                  width="100%"
                                  height={35}
                                />
                              </div>
                            </div>
                          </div>
                        </CardActionArea>
                      </>
                    );
                  })}
            </>
          );
        }}
      </Query>
    </>
  );
};

export default BlogGrid;
